import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { NotifyMessage } from '../models/notify-message';

const DEFAULT_TITLE = 'Attenzione!';
const DEFAULT_MESSAGE =
  'Operazione non reversibile, sicuro di voler continuare?';

@Injectable()
export class ModalNotifyService {
  private _notifyMsg: Subject<NotifyMessage> = new Subject();
  public notifyMsg: Observable<NotifyMessage> = this._notifyMsg.asObservable();

  private title: string = 'Conferma';
  public notifyConfirm: Subject<boolean> = new Subject();
  public notifyConfirmObservable: Observable<
    boolean
  > = this.notifyConfirm.asObservable();

  notifySuccessCallback(response, redirectTo: string, fascicoloId: string) {
    if (response.returnCode === 'OK') {
      let notifyMsgDescription = response.okMessages[0];
      this.title = 'Messaggio di Conferma';
      let msg: NotifyMessage = new NotifyMessage(
        true,
        notifyMsgDescription,
        redirectTo,
        fascicoloId,
        false,
        false,
        true,
        this.title
      );
      this.notify(msg);
    }
  }

  notifySuccessCompleteFascicolo(
    response,
    redirectTo: string,
    fascicoloId: string,
    msgSuccess: string
  ) {
    if (response.returnCode === 'OK') {
      let notifyMsgDescription = msgSuccess;
      this.title = 'Messaggio di Conferma';
      let msg: NotifyMessage = new NotifyMessage(
        true,
        notifyMsgDescription,
        redirectTo,
        fascicoloId,
        false,
        false,
        true,
        this.title
      );
      this.notify(msg);
    }
  }

  notifyDeletePratica() {
    let notifyMsgDescription = 'Eliminare la pratica e le notifiche correlate?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyEvadiScadenza() {
    let msg: NotifyMessage = new NotifyMessage(true, 'Sei sicuro di voler evadere evadere l\'adempimento selezionato?', null, null, true, true, false, this.title);
    this.notify(msg);
  }

  notifyEliminaScadenza() {
    let msg: NotifyMessage = new NotifyMessage(true, 'Sei sicuro di voler eliminare l\'adempimento selezionato?', null, null, true, true, false, this.title);
    this.notify(msg);
  }

  notifyESalvaConfig(str) {
    let msg: NotifyMessage = new NotifyMessage(true, str, null, null, true, true, false, this.title);
    this.notify(msg);
  }

  notifyEliminazione() {
    let msg: NotifyMessage = new NotifyMessage(true, 'Sei sicuro di voler procedere?', null, null, true, true, false, this.title);
    this.notify(msg);
  }

  notifyEliminaAnagrafica() {
    let msg: NotifyMessage = new NotifyMessage(
      true,
      "Sei sicuro di voler disabilitare l'anagrafica selezionata?",
      null,
      null,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  notifyEliminaContrtto() {
    let msg: NotifyMessage = new NotifyMessage(
      true,
      "Sei sicuro di voler eliminare il contratto e le tariffe in esso contenute?",
      null,
      null,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  notifyEliminaTariffa() {
    let msg: NotifyMessage = new NotifyMessage(
      true,
      "Sei sicuro di voler eliminare la tariffa?",
      null,
      null,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteCorrelazionePratica() {
    let notifyMsgDescription = 'Eliminare la correlazione?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteìPraticaPrecedente() {
    let notifyMsgDescription =
      'Eliminare la relazione con la pratica precedente?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteFascicolo() {
    let notifyMsgDescription = 'Eliminare il fascicolo e le notifiche correlate?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteDefinizioneFascicolo() {
    let notifyMsgDescription = 'Eliminare la definizione del fascicolo?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteRiunioneGiudizio() {
    let notifyMsgDescription = 'Eliminare la riunione giudizi del fascicolo?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteTemplateProfilo() {
    let notifyMsgDescription = 'Eliminare il template?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  notifyDeleteUtenteProfilo() {
    let notifyMsgDescription = "Eliminare l'utente?"; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyAndExitCallback() {
    let notifyMsgDescription = 'Confermi di voler uscire?'; // TODO: creare file di configurazione per testo dei messaggi
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      false,
      false,
      true,
      this.title
    );
    this.notify(msg);
  }

  notifyCustom(msgAlert: string) {
    let notifyMsgDescription = msgAlert;
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      redirectToHome,
      fascicoloId,
      true,
      true,
      true,
      this.title
    );
    this.notify(msg);
  }

  notify(msg: NotifyMessage) {
    this._notifyMsg.next(msg);
  }

  genericSuccessMessage(msg: string = 'Operazione avvenuta con successo') {
    this.title = 'Messaggio di Conferma';
    this.notify(
      new NotifyMessage(
        true,
        msg,
        null,
        null,
        false,
        false,
        false,
        this.title
      )
    );
  }

  customMessage(msg: string) {
    this.notify(
      new NotifyMessage(false, msg, null, null, false, false, false, this.title)
    );
  }

  messaggioCustom(msg: string, title:string){
    this.notify(
      new NotifyMessage(false, msg, null, null, false, false, false, title)
    );
  }

  noResult() {
    this.title = 'Attenzione!';
    this.notify(
      new NotifyMessage(
        true,
        'Nessun risultato trovato',
        null,
        null,
        false,
        false,
        false,
        this.title
      )
    );
  }

  notifyErrors(listErrors: string) {
    this.title = 'Messaggio di Errore!';
    this.notify(
      new NotifyMessage(
        true,
        listErrors,
        null,
        null,
        false,
        false,
        false,
        this.title
      )
    );
  }

  genericErrorMessage(msg: string) {
    this.title = 'Messaggio di Errore!';
    this.notify(
      new NotifyMessage(true, msg, null, null, false, false, false, this.title)
    );
  }

  genericMessageWithConfirm(
    title: string = DEFAULT_TITLE,
    msg: string = DEFAULT_MESSAGE
  ): Observable<boolean> {
    this._notifyMsg.next(
      new NotifyMessage(true, msg, null, null, true, true, false, title)
    );
    return this.notifyConfirmObservable.pipe(first());
  }

  notifyIMportSole24Ore() {
    let msg: NotifyMessage = new NotifyMessage(true, 'Il documento verrà importato nella sezione "Documentazione allegata" del fascicolo. Sei sicuro di voler continuare?', null, null, true, true, false, this.title);
    this.notify(msg);
  }


  notifyOkWithCallback(title : string, msg: string){
    let mn: NotifyMessage = new NotifyMessage(
      true, // openModal: boolean
      msg,  // messageDescription: string
      null, // redirectTo: string
      null, // fascicoloId: string
      false,// doppiaScelta: boolean
      true, // callbackConfirm: boolean
      false,// redirect: boolean
      title ?? this.title // title: string
    );
    this.notify(mn);
  }

  eliminaPartiConReatiMessage() {
    let notifyMsgDescription = 'Questa parte potrebbe avere reati associati. Sei sicuro di volerla cancellare?';
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      null,
      null,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

  modificaPartiConReatiMessage() {
    let notifyMsgDescription = 'Questa parte potrebbe avere reati associati. Sei sicuro di volerla modificare?';
    let redirectToHome = '';
    let fascicoloId = null;
    let msg: NotifyMessage = new NotifyMessage(
      true,
      notifyMsgDescription,
      null,
      null,
      true,
      true,
      false,
      this.title
    );
    this.notify(msg);
  }

}